<div class="fdm-sidenav" [class.collapsed]="collapsed">
  <div class="sidebar-toggle" (click)="toggleSidebar()">
    <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </div>

  <div class="nav-section">
    <div class="section-header"><span *ngIf="!collapsed">Records</span></div>
    <div class="nav-item" [routerLink]="['./reports']" routerLinkActive="active">
      <mat-icon>grid_view</mat-icon>
      <span *ngIf="!collapsed">FIRM Deviation Management</span>
    </div>
    <div class="nav-item" [routerLink]="['./action-items']" routerLinkActive="active">
      <mat-icon>assignment</mat-icon>
      <span *ngIf="!collapsed">FDM Action Items</span>
    </div>

    <!-- hide for test/prod -->
    @if (isDev) {
      <div class="nav-item" [routerLink]="['./my-approvals']" routerLinkActive="active">
        <mat-icon>how_to_reg</mat-icon>
        <span *ngIf="!collapsed">My Approvals</span>
      </div>
    }

    <div class="section-header"><span *ngIf="!collapsed">References</span></div>
    <div class="nav-item" [routerLink]="['./damage-mechanisms']" routerLinkActive="active">
      <mat-icon>error_outline</mat-icon>
      <span *ngIf="!collapsed">Damage Mechanisms/Failure Mode</span>
    </div>
    <!-- <div class="nav-item">
      <mat-icon>groups</mat-icon>
      <span *ngIf="!collapsed">Functional Groups</span>
    </div> -->
    <div class="nav-item" [routerLink]="['./facility-owners']" routerLinkActive="active">
      <mat-icon>people</mat-icon>
      <span *ngIf="!collapsed">Facility Owners</span>
    </div>
    <div class="nav-item" [routerLink]="['./distribution-list']" routerLinkActive="active">
      <mat-icon>mail</mat-icon>
      <span *ngIf="!collapsed">FDM Distribution List</span>
    </div>
    <!-- <div class="nav-item">
      <mat-icon>list</mat-icon>
      <span *ngIf="!collapsed">ITR Distribution List</span>
    </div>
    <div class="nav-item">
      <mat-icon>list</mat-icon>
      <span *ngIf="!collapsed">AR Distribution List</span>
    </div> -->

    <!-- hide for test/prod -->
    @if (isDev) {
      <div class="section-header"><span *ngIf="!collapsed">Help Section</span></div>
      <div class="nav-item">
        <mat-icon>rule</mat-icon>
        <span *ngIf="!collapsed">FIRM Standards</span>
      </div>
    }

    <div class="section-header"><span *ngIf="!collapsed">Dashboards</span></div>
    <div class="nav-item" (click)="openPowerBiReport()" matTooltip="Power BI. Export list of reports to Excel">
      <mat-icon>insert_chart_outlined</mat-icon>
      <span *ngIf="!collapsed" class="nav-item-multiline">Power BI. Export list of reports to Excel</span>
    </div>
  </div>
  <div class="nav-footer">
    @if (isDev) {
      <button mat-button disableRipple matTooltip="Settings" class="nav-item" [routerLink]="['./settings']"
        routerLinkActive="active">
        <mat-icon>settings</mat-icon>
        <span *ngIf="!collapsed">Settings</span>
      </button>
    }
    <button mat-button disableRipple class="nav-item" *ngIf="!auth.isSignedIn()" (click)="login()">
      <mat-icon>login</mat-icon>
      <span *ngIf="!collapsed">Login</span>
    </button>

    <ng-container *ngIf="auth.isSignedIn()">
      <button mat-button disableRipple class="nav-item" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span *ngIf="!collapsed">Logout</span>
      </button>
    </ng-container>
    <!-- <button mat-button disableRipple matTooltip="About" class="nav-item" [routerLink]="['./about']"
      routerLinkActive="active">
      <mat-icon>help_outline</mat-icon>
      <span *ngIf="!collapsed">About</span>
    </button> -->
    <div class="user-info" matTooltip="{{ userName() }} {{ userEmail() }}">
      <div class="user-avatar">
        {{ userInitials() }}
      </div>
      <div class="user-details" *ngIf="!collapsed">
        <div class="user-name">{{ userName() || 'User Name' }}</div>
        <div class="user-email">{{ userEmail() || 'user@example.com' }}</div>
      </div>
    </div>
  </div>
</div>
